import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loading$ = new BehaviorSubject<boolean>(false);
  public isLoading$ = this._loading$.asObservable();

  constructor() {}

  show() {
    this._loading$.next(true);
  }

  hide() {
    this._loading$.next(false);
  }
}
